import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { ApiError } from '../../../lib/errors';
import { rpaRepository as repo } from '../../../lib/repositories/rpa.repository';
import { CHU_KY_TASK_MS, conDangChay } from '../nghiep-vu/agent';
import type { HanhDongAgent, TaskAgent, ThanTaskAgent, TrangThaiAgent, XemTruocHanhDong } from '../types';
import { KHOA_RPA, thuLai } from './useRpa';

export function useTrangThaiAgent(bat = true) {
  return useQuery<TrangThaiAgent, ApiError>({
    queryKey: KHOA_RPA.trangThaiAgent,
    queryFn: () => repo.trangThaiAgent(),
    enabled: bat,
    staleTime: 30_000,
    retry: thuLai,
  });
}

/** 50 task mới nhất; còn task hoặc hành động đang chạy thì hỏi lại mỗi 4 giây (như native), xong hết thì thôi. */
export function useTaskAgent(bat = true) {
  return useQuery<TaskAgent[], ApiError>({
    queryKey: KHOA_RPA.taskAgent,
    queryFn: () => repo.taskAgent(),
    enabled: bat,
    staleTime: 10_000,
    retry: thuLai,
    refetchInterval: (q) => (conDangChay(q.state.data) ? CHU_KY_TASK_MS : false),
  });
}

function useLamMoiTask() {
  const qc = useQueryClient();
  return () => void qc.invalidateQueries({ queryKey: KHOA_RPA.taskAgent });
}

export function useGiaoTaskAgent() {
  const lamMoi = useLamMoiTask();
  return useMutation<TaskAgent, ApiError, ThanTaskAgent>({ mutationFn: (than) => repo.giaoTaskAgent(than), onSettled: lamMoi });
}

export function useHuyTaskAgent() {
  const lamMoi = useLamMoiTask();
  return useMutation<TaskAgent, ApiError, string>({ mutationFn: (id) => repo.huyTaskAgent(id), onSettled: lamMoi });
}

/** Xem trước hành động trước khi thực thi: đối chiếu đề xuất với OpenCore, Project chạy được. Không cache lâu. */
export function useXemTruocHanhDong(taskId: string, index: number) {
  return useQuery<XemTruocHanhDong, ApiError>({
    queryKey: KHOA_RPA.xemTruocHanhDong(taskId, index),
    queryFn: () => repo.xemTruocHanhDong(taskId, index),
    staleTime: 0,
    gcTime: 0,
    retry: thuLai,
  });
}

export function useThucThiHanhDong() {
  const lamMoi = useLamMoiTask();
  return useMutation<HanhDongAgent, ApiError, { taskId: string; index: number; projectId?: string }>({
    mutationFn: ({ taskId, index, projectId }) => repo.thucThiHanhDong(taskId, index, projectId ? { projectId } : {}),
    onSettled: lamMoi,
  });
}
